import * as Yup from 'yup';
import PropTypes from 'prop-types';

export const useRemoteFilter = ({ setFilters }) => {
  const formSchema = Yup.object().shape({
    remote: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ remote }) => {
    const remoteValue = remote.value || 'any';
    setFilters(
      { remote: remoteValue },
      {
        removeFilters: remoteValue === 'any' ? ['remote'] : [],
      },
    );
  };

  return {
    formSchema,
    onSubmit,
  };
};

useRemoteFilter.propTypes = {
  setFilters: PropTypes.func.isRequired,
};
